KXL.module('Components.ErrorPage', function(ErrorPage, KXL, Backbone, Marionette, $, _) {
	KXL.reqres.setHandlers({
		'new:error:view': function (options) {
			return new ErrorPage.View(options);
		}
	});
});